import { SHIPPING_CHARGE } from "../constants";
import { CartItem, CheckoutFormData, OrderTotals } from "../types";

export const isBrowser = () => typeof window !== "undefined";
export const getLocalStorage = (itemName: string) => {
  if (isBrowser()) {
    const item = window.localStorage.getItem(itemName);
    return item ? JSON.parse(item) : null;
  }
  return null;
};
export const setLocalStorage = (itemName: string, item: any) => {
  window.localStorage.setItem(itemName, JSON.stringify(item));
};
export const removeLocalStorage = (itemName: string) => {
  window.localStorage.removeItem(itemName);
};
export const formatPhone = (number: string) => {
  return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
};
export function convertCentsToCurrency(cents: number) {
  return `${(cents / 100).toFixed(2)}`;
}
export function getPriceInCents(price: string) {
  return parseInt(price.replace(/\D/g, ""));
}

const COFFEE_DISCOUNT_AMOUNT = 500;
const COFFEE_DISCOUNT_QUANTITY = 3;

export const getOrderSubtotalAndDiscount = (cartItems: CartItem[]) => {
  let orderSubtotal = 0;
  let coffeeOrderQuantity = 0;

  cartItems.forEach(item => {
    orderSubtotal += item.price * item.quantity;
    if (item.category === "coffee") {
      coffeeOrderQuantity += item.quantity;
    }
  });

  const coffeeBulkDiscount =
    Math.floor(coffeeOrderQuantity / COFFEE_DISCOUNT_QUANTITY) *
    COFFEE_DISCOUNT_AMOUNT;

  const dogTreatBulkDiscount = 0;

  const bulkDiscount = coffeeBulkDiscount + dogTreatBulkDiscount;

  return { orderSubtotal, bulkDiscount };
};
export const getOrderTotals = (
  cartItems: CartItem[],
  couponData: CheckoutFormData["couponData"],
  isShipping: boolean
): OrderTotals => {
  const { orderSubtotal, bulkDiscount } = getOrderSubtotalAndDiscount(
    cartItems
  );
  let orderTotal = orderSubtotal;
  const shippingCharge = isShipping ? SHIPPING_CHARGE : 0;
  if (couponData) {
    orderTotal -= couponData.discount;
  }
  orderTotal -= bulkDiscount;
  orderTotal += shippingCharge;
  return {
    orderTotal,
    orderSubtotal,
    couponData,
    bulkDiscount,
    shippingCharge,
  };
};
